export const DELETED_STATUS = 'deleted';
export const CANCELLED_STATUS = 'cancelled';
export const DRAFT_STATUS = 'draft';
export const PUBLISHED_STATUS = 'published';
